import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=20edceb6"
import script from "./Prize.vue?vue&type=script&lang=js"
export * from "./Prize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports